import '../App.css';
// import '../js/main.js';
import Green from '../json/data.json';


export default function Main(){

    // mainJs.mainJs();

    let btnName = [ 'mGoodsBtn','mMemoryBtn','mHistoryBtn','mNoticeBtn','mDrinkBtn','mBusBtn','mPlayBtn','mStarBtn' ];
    let detailName = [], overName = [], infoName =[];

    Green.MAINDETAIL.map( (detail,k) => (  detailName.push(detail['img']) )) // 기본 사진
    Green.MAINDETAILOVER.map( (detail,k) => (  overName.push(detail['img']) )) // 호버 사진
    Green.MAINDETAILOVERINFO.map( (detail,k) => (  infoName.push(detail['img']) )) // 호버 정보

    return(
        <>
        <div className="main">
            <p>
                <img src={require("../img/main_sign.png").default} alt="" className="mainSign"/>
                <img src={require("../img/main_banner.png").default} alt="" className="mainBanner"/>
                <img src={require("../img/main_logo.png").default} alt="" className="mainLogo"/>
            </p>
            <div>
                <img src={require("../img/main_area.png").default} alt="" className="mainPic"/>
                <img src={require("../img/main_person.png").default} alt="" className="mPerson"/>
                <div className="mainDetail">
                    {
                        detailName.map( (name,k) => {
                            return <img key={k} src={require(`../img/${name}`).default} alt=""/>
                        })
                    }
                </div>
                <div className="mainDetailOver">
                    {
                        overName.map( (name,k) => {
                            return <img key={k} src={require(`../img/${name}`).default} alt=""/>
                        })
                    }
                </div>
                <div className="mainDetailOverInfo">
                    {
                        infoName.map( (name,k) => {
                            return <img key={k} src={require(`../img/${name}`).default} alt=""/>
                        })
                    }
                </div>
                <div className="mainDetaiBtn">
                    {
                        btnName.map((name,k) => (
                            <button key={k} className={name}>+</button>
                        ))
                    }
                </div>
            </div>
        </div>
        <script type="test/javascript" src="../js/main.js"/>
        </>
    )
    
}